<template>
  <div data-component="app-launcher-links">
    <div
      v-for="option of options"
      :key="option.key"
      :class="{ 'is-disabled': isDisabled }"
      :data-launcher-option="option.key"
    >
      <div class="icon-wrapper">
        <or-icon :icon="option.icon" />
      </div>

      <span class="label">
        {{ $t(option.label) }}
      </span>

      <or-button
        data-button="go-to"
        :disabled="isDisabled"
        @click="onClick(option.key)"
      >
        {{ $t('HITL.common.actions.open') }}
        <or-icon icon="arrow_forward" />
      </or-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import {
  OrIconV3 as OrIcon,
  OrButtonV3 as OrButton,
} from '@onereach/ui-components-25';
import { AppOption } from '../types';
import { APPS } from '../constants';

export default defineComponent({
  name: 'AppLauncherLinks',
  components: { OrIcon, OrButton },
  props: {
    isDisabled: Boolean,
  },
  emits: ['go-to'],
  computed: {
    options() {
      const apps = Object.keys(APPS) as (keyof typeof APPS)[];
      const options: AppOption[] = [];

      for (const app of apps) {
        options.push(APPS[app]);
      }

      return options;
    },
  },
  methods: {
    onClick(option: string) {
      if (!this.isDisabled) {
        this.$emit('go-to', option);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-links'] {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
  width: 100%;

  @include md {
    width: 40rem;
  }

  [data-launcher-option] {
    display: flex;
    align-items: center;
    gap: var(--s-4);
    height: 5.25rem;
    padding: var(--s-4);
    border-radius: var(--s-2);
    background: var(--or-c-background);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
      0px 1px 2px rgba(24, 28, 34, 0.15);

    &.is-disabled {
      .icon-wrapper {
        background-color: var(--or-c-disabled);
      }

      .icon-wrapper .or-icon-v3,
      .label {
        color: var(--or-c-on-disabled);
      }
    }

    .icon-wrapper {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      height: 3.25rem;
      width: 3.25rem;
      border-radius: var(--s-2);
      background: var(--or-c-primary-opacity-0-08);

      .or-icon-v3 {
        font-size: 1.25rem;
        color: var(--or-c-outline);
      }
    }

    .label {
      @include text-overflow;
      color: var(--or-c-on-background);
    }

    [data-button='go-to'] {
      flex: 0 0 auto;
      margin-left: auto;
    }
  }
}
</style>
